import React from 'react';

import './Figure.scss';

import { SvgList, SvgMap, SvgDatabase, Icon, SIZE } from '@tmapy/style-guide';

import { EDAS_TYPE } from '../constants';

type FigureProps = {
  src: string;
  color?: string;
  type: EDAS_TYPE;
};

const getFigureIcon = (type: EDAS_TYPE) => {
  switch (type) {
    case EDAS_TYPE.app:
      return <SvgList />;
    case EDAS_TYPE.mapApp:
      return <SvgMap />;
    case EDAS_TYPE.dataset:
      return <SvgDatabase />;
    default:
      return <></>;
  }
};

export const Figure: React.FC<FigureProps> = (props) => {
  return (
    <figure className='e-figure'>
      {props.src ? (
        <img
          className='e-figure--image'
          src={props.src}
          alt=''
          loading='lazy'
          style={{ backgroundColor: props.color }}
        />
      ) : (
        <div className='e-figure--placeholder'>
          <Icon element={getFigureIcon(props.type)} size={SIZE.MED} />
        </div>
      )}
    </figure>
  );
};
